<template>
  <i v-if="shouldShow_TrackLayerAudio" class="tm-tracks-audio">
    <slot />
  </i>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'tm-tracks-audio',

  computed: {
    ...mapGetters('timemachine', ['shouldShow_TrackLayerAudio']),
  },
};
</script>

<style lang="scss">
.tm-tracks > .tm-tracks-audio {
}
</style>
